export const pricingData = [
  {
    key: "1",
    SEASONNAME: "Halloween",
    STARTDATE: "20 Sep 2025",
    ENDDATE: "25 Nov 2025",
    DAILYRATE: "$200",
    WEEKLYRATE: "$1400",
    MONTHLYRATE: "$4800",
    STATUS: "Active",
  },
  {
    key: "2",
    SEASONNAME: "Easter",
    STARTDATE: "01 Jun 2025",
    ENDDATE: "15 Aug 2025",
    DAILYRATE: "$220",
    WEEKLYRATE: "$1540",
    MONTHLYRATE: "$6160",
    STATUS: "Active",
  },
  {
    key: "3",
    SEASONNAME: "New Year",
    STARTDATE: "15 Mar 2025",
    ENDDATE: "20 May 2025",
    DAILYRATE: "$240",
    WEEKLYRATE: "$1680",
    MONTHLYRATE: "$6720",
    STATUS: "Active",
  },
  {
    key: "4",
    SEASONNAME: "Christmas",
    STARTDATE: "01 Dec 2024",
    ENDDATE: "10 Jan 2025",
    DAILYRATE: "$250",
    WEEKLYRATE: "$1750",
    MONTHLYRATE: "$7000",
    STATUS: "Active",
  },
];
